import Marquee from "react-fast-marquee";
import { Sprout } from "lucide-react";

const ITEMS = [
  "OAK GROVE, MO",
  "GRAIN VALLEY, MO",
  "FAIR STARTING PRICES",
  "BOOK ONLINE IN MINUTES",
  "TEEN-RUN & HARD-WORKING",
  "LOCAL WORK, EVERY SEASON",
];

export default function EditorialMarquee() {
  return (
    <div data-testid="editorial-marquee" className="bg-pine py-4 border-y border-pine-dark overflow-hidden">
      <Marquee speed={30} gradient={false} pauseOnHover>
        {ITEMS.map((item) => (
          <span key={item} className="flex items-center gap-6 mx-6">
            <span className="font-display font-bold text-sm sm:text-base tracking-[0.18em] text-bone/90 whitespace-nowrap">
              {item}
            </span>
            <Sprout size={15} className="text-limed-bright shrink-0" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
